<template lang="pug">
  div
    template(v-for="(office, officeNumber) in offices")
      template(v-if="initStateForOffice(officeNumber)")
        hr
        h4.box-title
          a(
            role="button",
            data-toggle="collapse",
            :href="`#jbcard-card-details-collapse-${_uid}-${officeNumber}`",
            aria-expanded="true",
            :aria-controls="`bcard-card-details-collapse-${_uid}-${officeNumber}`"
          )
            | 事業所{{officeNumber + 1}}
            |
            |
            i.fa.fa-caret-down
            i.fa.fa-caret-up

        .collapse.in(
          :id="`jbcard-card-details-collapse-${_uid}-${officeNumber}`",
          role="tabpanel",
          :aria-labelledby="`jbcard-card-details-heading-${officeNumber}`",
          data-testid="-content-office"
        )
          .row
            .col-md-6.col-sm-12.col-xs-6.bcard-card-details-card-info-items
              .media(v-if="office.name.length > 0")
                .media-left.media-middle
                  i.fa.fa-2x.fa-fw.fa-building-o(:title="`事業所${officeNumber + 1}`")
                .media-body.media-middle(data-testid="-office")
                  | {{office.name}}
              .media(v-if="hasAnyNumbers(officeNumber)")
                .media-left.media-middle
                  i.fa.fa-2x.fa-fw.fa-phone(title="電話番号")
                .media-body.media-middle
                  dl.dl-horizontal.bcard-card-details-card-info-items
                    dt 番号1
                    dd(data-testid="-tel1") {{office.tel1}}
                    dt 内線1
                    dd(data-testid="-naisen1") {{office.naisen1}}
                    dt 番号2
                    dd(data-testid="-tel2") {{office.tel2}}
                    dt 内線2
                    dd(data-testid="-naisen2") {{office.naisen2}}
                    dt 携帯
                    dd(data-testid="-mobile") {{office.mobile}}
                    dt FAX
                    dd(data-testid="-fax") {{office.fax}}
            .col-md-6.col-sm-12.col-xs-6
              .media(v-if="office.zipcode.length > 0 || office.address1.length > 0 || office.address2.length > 0")
                .media-left.media-middle
                  i.fa.fa-2x.fa-fw.fa-map-marker(title="住所")
                .media-body.media-middle
                  div(v-if="office.zipcode.length > 0", data-testid="-zipcode") 〒{{office.zipcode}}
                  div(data-testid="-address")
                    address-link(:addresses="[office.address1, office.address2]")
              .media(v-if="office.mail.length > 0")
                .media-left.media-middle
                  i.fa.fa-2x.fa-fw.fa-envelope-o(title="メール")
                .media-body.media-middle
                  a(:href="'mailto:' + office.mail", data-testid="-mail") {{office.mail}}
              .media(v-if="office.url.length > 0")
                .media-left.media-middle
                  i.fa.fa-2x.fa-fw.fa-link(title="URL")
                .media-body.media-middle
                  a(:href="office.valid_url" target="_blank", data-testid="-url") {{office.url}}
</template>

<script>
import AddressLink from '@/components/molecules/AddressLink'

export default {
  name: 'CardOfficeView',
  components: { AddressLink },
  props: {
    // 1名刺の履歴
    bcard: {
      type: [Object],
      required: true
    }
  },
  computed: {
    // 事務所1と事務所2の項目を配列にする
    offices: function () {
      return [
        {
          'name': this.bcard.o1_office_name || '',
          'tel1': this.bcard.o1_tel1 || '',
          'naisen1': this.bcard.o1_naisen1 || '',
          'tel2': this.bcard.o1_tel2 || '',
          'naisen2': this.bcard.o1_naisen2 || '',
          'mobile': this.bcard.o1_mobile || '',
          'fax': this.bcard.o1_fax || '',
          'zipcode': this.bcard.o1_zipcode || '',
          'address1': this.bcard.o1_address1 || '',
          'address2': this.bcard.o1_address2 || '',
          'mail': this.bcard.o1_mail || '',
          'url': this.bcard.o1_url || '',
          'valid_url': this.bcard.valid_o1_url || ''
        },
        {
          'name': this.bcard.o2_office_name || '',
          'tel1': this.bcard.o2_tel1 || '',
          'naisen1': this.bcard.o2_naisen1 || '',
          'tel2': this.bcard.o2_tel2 || '',
          'naisen2': this.bcard.o2_naisen2 || '',
          'mobile': this.bcard.o2_mobile || '',
          'fax': this.bcard.o2_fax || '',
          'zipcode': this.bcard.o2_zipcode || '',
          'address1': this.bcard.o2_address1 || '',
          'address2': this.bcard.o2_address2 || '',
          'mail': this.bcard.o2_mail || '',
          'url': this.bcard.o2_url || '',
          'valid_url': this.bcard.valid_o2_url || ''
        }
      ]
    }
  },
  methods: {
    // 電話番号があるかどうか
    hasAnyNumbers: function (num) {
      return (
        this.offices[num].tel1.length > 0 ||
        this.offices[num].naisen1.length > 0 ||
        this.offices[num].tel2.length > 0 ||
        this.offices[num].naisen2.length > 0 ||
        this.offices[num].mobile.length > 0 ||
        this.offices[num].fax.length > 0
      )
    },
    // 各事業所のパネル開閉状況の初期状態
    initStateForOffice: function (num) {
      // 事業所のデータが一つでもある場合はtrue
      return (
        this.offices[num].name.length > 0 ||
        this.hasAnyNumbers(num) ||
        this.offices[num].zipcode.length > 0 ||
        this.offices[num].address1.length > 0 ||
        this.offices[num].address2.length > 0 ||
        this.offices[num].zipcode.length > 0 ||
        this.offices[num].mail.length > 0 ||
        this.offices[num].url.length > 0
      )
    }
  }
}
</script>

<style lang="scss" scoped>
  .box-title {
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/organisms/views/CardOfficeView.vue